export default __webpack_public_path__ + "static/media/6.effee24a.jpeg";